var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5881 8.38273C16.9786 7.99221 17.6118 7.99221 18.0023 8.38273C18.3928 8.77326 18.3928 9.40642 18.0023 9.79695L12.7375 15.0605C11.7624 16.0354 10.182 16.0367 9.20527 15.0633L7.39055 13.2548C7.00002 12.8643 7.00002 12.2311 7.39055 11.8406C7.78107 11.4501 8.41424 11.4501 8.80476 11.8406L10.2604 13.2962C10.6509 13.6868 11.2841 13.6868 11.6746 13.2962L16.5881 8.38273Z",
    fill: "#50C878"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6836 23C18.7587 23 23.6836 18.0751 23.6836 12C23.6836 5.92487 18.7587 1 12.6836 1C6.60846 1 1.68359 5.92487 1.68359 12C1.68359 18.0751 6.60846 23 12.6836 23ZM12.6836 20.9932C7.7168 20.9932 3.69042 16.9668 3.69042 12C3.69042 7.03321 7.7168 3.00683 12.6836 3.00683C17.6504 3.00683 21.6768 7.03321 21.6768 12C21.6768 16.9668 17.6504 20.9932 12.6836 20.9932Z",
    fill: "#50C878"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleRight);
export default __webpack_public_path__ + "static/media/circle_right.29b3f8d2c2b2e33dfefe1449be49b966.svg";
export { ForwardRef as ReactComponent };